/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UpdateOrganizationChatSettingRequestOrganizationChatSetting,
  UpdateOrganizationChatSettingRequestOrganizationChatSettingFromJSON,
  UpdateOrganizationChatSettingRequestOrganizationChatSettingFromJSONTyped,
  UpdateOrganizationChatSettingRequestOrganizationChatSettingToJSON
} from './UpdateOrganizationChatSettingRequestOrganizationChatSetting'

/**
 *
 * @export
 * @interface UpdateOrganizationChatSettingRequest
 */
export interface UpdateOrganizationChatSettingRequest {
  /**
   *
   * @type {UpdateOrganizationChatSettingRequestOrganizationChatSetting}
   * @memberof UpdateOrganizationChatSettingRequest
   */
  organizationChatSetting?: UpdateOrganizationChatSettingRequestOrganizationChatSetting
}

export function UpdateOrganizationChatSettingRequestFromJSON(json: any): UpdateOrganizationChatSettingRequest {
  return UpdateOrganizationChatSettingRequestFromJSONTyped(json, false)
}

export function UpdateOrganizationChatSettingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateOrganizationChatSettingRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    organizationChatSetting: !exists(json, 'organization_chat_setting')
      ? undefined
      : UpdateOrganizationChatSettingRequestOrganizationChatSettingFromJSON(json['organization_chat_setting'])
  }
}

export function UpdateOrganizationChatSettingRequestToJSON(value?: UpdateOrganizationChatSettingRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    organization_chat_setting: UpdateOrganizationChatSettingRequestOrganizationChatSettingToJSON(
      value.organizationChatSetting
    )
  }
}
